import styled from 'styled-components';

export const StyledHeader = styled.div`
    font-family: var(--font-family);
    display: flex;
    min-height: 84px;
    max-width: 400px;
    height: fit-content;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 40px ${({ isProfileInfo }: any) => (isProfileInfo ? '0' : '44px')}
        0 1em;
    padding-right: 1em;
    position: relative;
    z-index: 1;
    margin: 0 auto;
    box-sizing: border-box;
    visibility: ${(props: any) => props.visibility};

    .logo {
        width: ${({ isProfileInfo }: any) =>
            isProfileInfo ? 'auto' : '128px'};
        height: ${({ isProfileInfo }: any) =>
            isProfileInfo ? '60px' : 'auto'};
        margin: ${({ isProfileInfo }: any) => (isProfileInfo ? '0' : 'auto')};
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        &__main {
            width: ${({ isProfileInfo }: any) =>
                isProfileInfo ? 'unset' : '100%'};
            height: ${({ isProfileInfo }: any) =>
                isProfileInfo ? '100%' : 'unset'};
            object-fit: contain;
        }

        &__sub {
            width: 150%;
        }
    }

    .profileContainer {
        cursor: pointer;
        height: ${({ isProfileInfo }: any) =>
            isProfileInfo ? 'fit-content' : '44px'};
        display: ${({ isProfileInfo }: any) =>
            isProfileInfo ? 'flex' : 'block'};
        align-items: ${({ isProfileInfo }: any) =>
            isProfileInfo ? 'center' : 'none'};
        flex: ${({ isProfileInfo }: any) => (isProfileInfo ? '1' : '0')};

        .frame {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            height: ${({ isProfileInfo }: any) =>
                isProfileInfo ? '40px' : '44px'};
            width: ${({ isProfileInfo }: any) =>
                isProfileInfo ? '40px' : '44px'};
            border-radius: 50%;
            margin-right: 5px;
        }

        &__profileFrame {
            position: absolute;
            height: ${({ isProfileInfo }: any) =>
                isProfileInfo ? '36px' : '44px'};
            width: ${({ isProfileInfo }: any) =>
                isProfileInfo ? '36px' : '44px'};
        }

        &__img {
            height: 90%;
            border-radius: 50%;
            background-color: gray;
        }

        &-info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: fit-content;
            flex: 1;
            gap: 2px;
            margin-left: 4px;
            color: white;
            font-size: 12px;
            line-height: normal;
            font-weight: 400;

            & > div:nth-child(2) {
                align-items: flex-start;
            }
        }

        .bagelCodeInfoContainer {
            margin-left: 4px;
        }
    }

    @media only screen and (orientation: landscape) and (max-width: 1280px) {
        padding: 40px 0 0;
        margin: 0 24px;
    }

    @media only screen and (min-width: 768px) {
        padding-right: ${({ isProfileInfo }: any) =>
            isProfileInfo ? '0' : '60px'};

        .profileContainer {
            height: ${({ isProfileInfo }: any) =>
                isProfileInfo ? 'fit-content' : '60px'};
            width: ${({ isProfileInfo }: any) =>
                isProfileInfo ? 'fit-content' : '60px'};

            .frame {
                height: ${({ isProfileInfo }: any) =>
                    isProfileInfo ? '48px' : '60px'};
                width: ${({ isProfileInfo }: any) =>
                    isProfileInfo ? '48px' : '60px'};
            }

            &-info {
                font-size: 1rem;
                margin-left: 8px;
            }

            &__profileFrame {
                height: ${({ isProfileInfo }: any) =>
                    isProfileInfo ? '48px' : '60px'};
                width: ${({ isProfileInfo }: any) =>
                    isProfileInfo ? '48px' : '60px'};
            }
        }

        .logo {
            width: ${({ isProfileInfo }: any) =>
                isProfileInfo ? 'auto' : '180px'};
            height: ${({ isProfileInfo }: any) =>
                isProfileInfo ? '64px' : 'auto'};

            &.big {
                width: 176px;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        height: ${({ isProfileInfo }: any) =>
            isProfileInfo ? 'fit-content' : '120px'};
        .defaultInfoLogo {
            position: absolute;
            left: 50%;
            transform: translate(-50%);
        }
    }

    @media only screen and (min-width: 1024px) {
        .logo {
            width: ${({ isProfileInfo }: any) =>
                isProfileInfo ? 'auto' : '196px'};
            height: ${({ isProfileInfo }: any) =>
                isProfileInfo ? '64px' : 'auto'};

            &.big {
                width: 220px;
            }
        }
    }

    @media only screen and (min-width: 1280px) {
        max-width: 1248px;
    }

    @media only screen and (min-width: 849px) and (max-width: 1279px) {
        max-width: 820px;
    }
` as any;
